import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import { FileX2 } from "lucide-react";
import OverviewTab from "@/components/portfolio/OverviewTab";
import PersonalClientsTab from "@/components/portfolio/PersonalClientsTab";
import PracticesTab from "@/components/portfolio/PracticesTab";
import RejectedTab from "@/components/portfolio/RejectedTab";
import ReevaluateTab from "@/components/portfolio/ReevaluateTab";

const TABS = [
  { id: "panoramica", label: "Panoramica" },
  { id: "clienti", label: "Clienti personali" },
  { id: "pratiche", label: "Pratiche e liquidazioni" },
  { id: "rifiutate", label: "Pratiche rifiutate" },
  { id: "rivalutare", label: "Da rivalutare" },
];

export default function PortfolioActivePage() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.id === params.get("tab")) ? params.get("tab") : "panoramica";
  const [clientPreset, setClientPreset] = useState(null);

  // tab nell'URL con replace: il tasto Indietro non accumula passaggi tra i tab
  const open = (t, preset = null) => {
    setClientPreset(preset);
    setParams({ tab: t }, { replace: true });
  };
  useEffect(() => { if (!params.get("tab")) setParams({ tab: "panoramica" }, { replace: true }); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AppLayout
      title="Portafoglio Attivo"
      subtitle="Clienti personali"
      actions={
        <button onClick={() => open("rifiutate")} data-testid="btn-rejected-history"
          className="px-3 py-2 text-sm font-semibold bg-rose-700 text-white rounded-[3px] hover:bg-rose-800 inline-flex items-center gap-2 whitespace-nowrap">
          <FileX2 className="w-4 h-4" /> Pratiche rifiutate — Tutto lo storico
        </button>
      }
    >
      <div className="flex gap-1 mb-5 overflow-x-auto no-scrollbar border-b border-slate-200" data-testid="pa-tabs">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => open(t.id)} data-testid={`pa-tab-${t.id}`}
            className={`px-3 sm:px-4 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${
              tab === t.id ? "border-[#B7955B] text-slate-900 font-semibold" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === "panoramica" && <OverviewTab onOpen={open} />}
      {tab === "clienti" && <PersonalClientsTab preset={clientPreset} />}
      {tab === "pratiche" && <PracticesTab />}
      {tab === "rifiutate" && <RejectedTab />}
      {tab === "rivalutare" && <ReevaluateTab />}
    </AppLayout>
  );
}
